// @ts-ignore
/* eslint-disable */
import type { CustomRequestOptions } from '../customRequestOptions';
import { request } from '../axios/sdpSecurity';

/** 获取支付密码控件初始化参数 GET /mch/pay/pwd/init */
export async function payPwdInit(options?: CustomRequestOptions) {
  return request<APISdpSecurity.ApiDataResponsePwdParamInitVO_>('/mch/pay/pwd/init', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取支付密码控件初始化参数 POST /mch/pay/pwd/init */
export async function payPwdInit_2(options?: CustomRequestOptions) {
  return request<APISdpSecurity.ApiDataResponsePwdParamInitVO_>('/mch/pay/pwd/init', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 修改支付密码 POST /mch/pay/pwd/modify */
export async function payPwdModify(
  body: APISdpSecurity.PayPwdModifyRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpSecurity.ApiBaseResponse>('/mch/pay/pwd/modify', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改操作员密码 POST /mch/pay/pwd/operator/modify */
export async function pwdOperatorModify(
  body: APISdpSecurity.OperatorPayPwdModifyRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpSecurity.ApiBaseResponse>('/mch/pay/pwd/operator/modify', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询支付密码是否设置 GET /mch/pay/pwd/query */
export async function payPwdQuery(options?: CustomRequestOptions) {
  return request<APISdpSecurity.ApiDataResponsePayPwdSetupVO_>('/mch/pay/pwd/query', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 重置支付密码-check登录密码 POST /mch/pay/pwd/reset/check/login/pwd */
export async function checkLoginPwd(
  body: APISdpSecurity.PayPwdResetCheckLoginPwdRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpSecurity.ApiBaseResponse>('/mch/pay/pwd/reset/check/login/pwd', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 重置支付密码-预校验 POST /mch/pay/pwd/reset/pre/check */
export async function resetPreCheck(options?: CustomRequestOptions) {
  return request<APISdpSecurity.ApiDataResponsePayPwdResetPreCheckVO_>(
    '/mch/pay/pwd/reset/pre/check',
    {
      method: 'POST',
      ...(options || {}),
    },
  );
}

/** 重置支付密码-发送短信验证码 POST /mch/pay/pwd/reset/send/captcha */
export async function resetSendCaptcha(
  body: APISdpSecurity.PayPwdResetSendCaptchaRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpSecurity.ApiDataResponseCaptchaVO_>('/mch/pay/pwd/reset/send/captcha', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 重置支付密码-提交 POST /mch/pay/pwd/reset/submit */
export async function pwdResetSubmit(
  body: APISdpSecurity.PayPwdResetRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpSecurity.ApiBaseResponse>('/mch/pay/pwd/reset/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
